// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3844":"87d5725ad6a940f2","5350":"025cba76c8381279","7794":"0f95c41b649b67ac"}[chunkId] + ".css";
};